import React, {Component} from "react"
import PropTypes from "prop-types"
import {connect} from "react-redux"
import {LearningModulesCreators as Creators} from "./redux"
import {Link} from "redux-little-router"
import {translate} from "react-i18next"

import {Container, Row, Col} from "../../components/Grid"
import Loader from "../../components/Loader"
import Button from "../../components/Button"
import Message from "../../components/Message"
import RemoteContent from "../../components/RemoteContent"
import Quiz from "../../components/Quiz"
import Certificate from "../../components/Certificate"
import ModuleCertificate from "../../components/ModuleCertificate"
import Feedback from "../../components/Feedback"
import {AppCreators} from "../App/redux"

import {
  checkEnv,
  dateToString,
  log,
  stickyNav,
  stickySidebar,
  textTruncate
} from "../../utils"

import styles from "./styles.css"

import graphicAcademyMed from "../../assets/svg/graphic-academy-med.svg"

import html2canvas from "html2canvas"
import jsPDF from "jspdf"

import api from "../../services/ApiService"

class LearningModules extends Component {
  constructor() {
    super()
    this.modalVideo = React.createRef()

    this.fetchArticles = this.fetchArticles.bind(this)
    this.doPrint = this.doPrint.bind(this)
    this.closePrint = this.closePrint.bind(this)
    this.doGlobalPrint = this.doGlobalPrint.bind(this)
    this.closeGlobalPrint = this.closeGlobalPrint.bind(this)
    this.doCrtPrint = this.doCrtPrint.bind(this)
    this.closeCrtPrint = this.closeCrtPrint.bind(this)
    this.openQuiz = this.openQuiz.bind(this)
    this.closeQuiz = this.closeQuiz.bind(this)
    this.openVideo = this.openVideo.bind(this)
    this.closeVideo = this.closeVideo.bind(this)
    this.maybeTrackResponse = this.maybeTrackResponse.bind(this)
    this.closePrintModuleCertificate = this.closePrintModuleCertificate.bind(
      this
    )
    this.moduleRefs = {}

    this.state = {
      activeDropdown: "",
      activeLink: "",
      isPrinting: false,
      isGlobalPrinting: false,
      isCrtPrinting: false,
      quizactive: false,
      videoactive: false,
      currentvideo: "",
      modulename: "",
      articlename: "",
      username: null,
      moduleCertificateId: null,
      isReload: false,
      tagFilters: {},
      feedbackVisible: false,
      lastUsedHash: ""
    }
  }

  static propTypes = {
    error: PropTypes.string,
    fetching: PropTypes.bool,
    topic: PropTypes.object.isRequired,
    modules: PropTypes.array.isRequired,
    articles: PropTypes.object.isRequired,
    quizpost: PropTypes.object.isRequired,
    tags: PropTypes.object.isRequired
  }

  static defaultProps = {
    topic: {},
    modules: [],
    articles: {},
    quizpost: {},
    tags: {},
    fetching: false,
    error: null
  }

  componentDidMount() {
    if (document.querySelector("body").classList.contains("overflow")) {
      document.querySelector("body").className = ""
    }
    if (!this.props.error && !this.props.fetching) {
      stickyNav(this.props.fetching)
      stickySidebar(this.props.fetching, false)
    }
  }

  componentDidUpdate() {
    if (!this.props.error && !this.props.fetching) {
      stickyNav(this.props.fetching)
      stickySidebar(this.props.fetching, false)
    }

    // check for hash and open module if it exists
    const hash = this._getHash()

    if (hash && this.moduleRefs[hash] && this.state.lastUsedHash !== hash) {
      this._scrollToModule(hash)
    }
  }

  fetchArticles(e) {
    e.preventDefault()
    let moduleslug = e.target.getAttribute("href")
    this.props.loadArticles(moduleslug)
    let self = this
    setTimeout(function() {
      self.setState(prevState => {
        return {
          ...prevState,
          isPrinting: true
        }
      })
    }, 500)
  }

  doPrint() {
    setTimeout(function() {
      window.print()
      return false
    }, 1000)
    let self = this
    setTimeout(function() {
      self.setState(prevState => {
        return {
          ...prevState,
          isPrinting: false
        }
      })
    }, 10000)
  }
  closePrint() {
    this.setState(prevState => {
      return {
        ...prevState,
        isPrinting: false
      }
    })
  }

  doGlobalPrint() {
    this.setState(prevState => {
      return {
        ...prevState,
        isGlobalPrinting: true
      }
    })
    setTimeout(function() {
      window.print()
      return false
    }, 1000)
    let self = this
    setTimeout(function() {
      self.setState(prevState => {
        return {
          ...prevState,
          isGlobalPrinting: false
        }
      })
    }, 7000)
  }
  closeGlobalPrint() {
    this.setState(prevState => {
      return {
        ...prevState,
        isGlobalPrinting: false
      }
    })
  }

  printCertificate(id, filename) {
    const doc = document.getElementById(id)

    setTimeout(function() {
      html2canvas(doc, {
        scale: 2,
        width: 690,
        height: 1120,
        scrollX: 0,
        scrollY: 0
      }).then(canvas => {
        var context = canvas.getContext("2d")
        context.webkitImageSmoothingEnabled = false
        context.mozImageSmoothingEnabled = false
        context.imageSmoothingEnabled = false
        context.scale(2, 2)
        context["imageSmoothingEnabled"] = false
        context["mozImageSmoothingEnabled"] = false
        context["oImageSmoothingEnabled"] = false
        context["webkitImageSmoothingEnabled"] = false
        context["msImageSmoothingEnabled"] = false
        const dataURL = canvas.toDataURL("image/png", 1)
        const pdf = new jsPDF("p", "mm", "a4", true)
        let marginLeft = 13
        let marginRight = 0
        pdf.internal.scaleFactor = 5.7

        pdf.addImage(
          dataURL,
          "PNG",
          marginLeft,
          marginRight,
          "",
          "",
          "",
          "FAST"
        )
        pdf.save(`${filename}.pdf`)
      })
    }, 1000)
  }

  doCrtPrint() {
    document.querySelector("html").classList.add("overflow")
    this.setState(prevState => {
      return {
        ...prevState,
        isCrtPrinting: true,
        username: this.props.userdata.user.display_name
      }
    })

    const crtTopicName = this.props.topic.name.replace(/\s/g, "-").toUpperCase()
    const crtCompletedDate = dateToString(
      this.props.topic.completed_at,
      this.props.lang
    )

    this.printCertificate(
      "crt-print",
      `MBMTL-ZERTIFIKAT-${crtTopicName}-${crtCompletedDate}`
    )

    setTimeout(this.closeCrtPrint, 3000)
  }

  closeCrtPrint() {
    document.querySelector("html").classList.remove("overflow")
    this.setState(prevState => {
      return {
        ...prevState,
        isCrtPrinting: false,
        username: null
      }
    })
  }

  printModuleCertificate(id) {
    document.querySelector("html").classList.add("overflow")

    this.setState(prevState => {
      return {
        ...prevState,
        moduleCertificateId: id
      }
    })

    const module = this.props.modules.filter(m => m.term_id === id)[0]
    const moduleName = module.name.replace(/\s/g, "-").toUpperCase()
    const moduleCompletedDate = dateToString(module.read_date, this.props.lang)

    this.printCertificate(
      `crt-print-module-${id}`,
      `MBMTL-ZERTIFIKAT-MODUL-${moduleName}-${moduleCompletedDate}`
    )

    setTimeout(this.closePrintModuleCertificate, 3000)
  }

  closePrintModuleCertificate() {
    this.setState(prevState => {
      return {
        ...prevState,
        moduleCertificateId: null
      }
    })
  }

  slideDropdownToggle(e) {
    e.stopPropagation()
    let target = e.target
    let dropdown = target.nextElementSibling
    if (target.classList.contains("is-active")) {
      target.classList.remove("is-active")
      dropdown.classList.remove("is-open")
      dropdown.style.height = "0px"
      dropdown.addEventListener(
        "transitionend",
        () => {
          dropdown.classList.remove("active")
        },
        {once: true}
      )
    } else {
      target.classList.add("is-active")
      dropdown.classList.add("is-open")
      dropdown.style.height = dropdown.scrollHeight + "px"
    }
    dropdown.onmouseleave = function() {
      target.classList.remove("is-active")
      dropdown.classList.remove("is-open")
      dropdown.style.height = "0px"
      dropdown.addEventListener(
        "transitionend",
        () => {
          dropdown.classList.remove("active")
        },
        {once: true}
      )
    }
    const outsideClickListener = event => {
      if (!target.contains(event.target)) {
        target.classList.remove("is-active")
        dropdown.classList.remove("is-open")
        dropdown.style.height = "0px"
        dropdown.addEventListener(
          "transitionend",
          () => {
            dropdown.classList.remove("active")
          },
          {once: true}
        )
        removeClickListener()
      }
    }
    const removeClickListener = () => {
      document.removeEventListener("click", outsideClickListener)
    }
    document.addEventListener("click", outsideClickListener)
  }

  slideToggle(e) {
    let activeDropdown = this.state.activeDropdown
    let activeLink = this.state.activeLink
    let dropdown = e.target.parentNode.parentNode.nextElementSibling
    e.preventDefault()
    if (e.target.classList.contains("is-active")) {
      e.target.classList.remove("is-active")
      dropdown.classList.remove("is-open")
      dropdown.style.height = "0px"
      dropdown.addEventListener(
        "transitionend",
        () => {
          dropdown.classList.remove("active")
        },
        {once: true}
      )
      this.setState(prevState => {
        return {
          ...prevState,
          activeDropdown: "",
          activeLink: ""
        }
      })
    } else {
      if (activeLink !== "") {
        activeLink.classList.remove("is-active")
      }
      if (activeDropdown !== "") {
        activeDropdown.classList.remove("is-open")
        activeDropdown.style.height = "0px"
        activeDropdown.addEventListener(
          "transitionend",
          () => {
            activeDropdown.classList.remove("active")
          },
          {once: true}
        )
      }

      e.target.classList.add("is-active")
      dropdown.classList.add("is-open")
      dropdown.style.height = "auto"
      var height = dropdown.clientHeight + "px"
      dropdown.style.height = "0px"
      setTimeout(() => {
        dropdown.style.height = height
      }, 0)

      activeLink = e.target
      this.setState(prevState => {
        return {
          ...prevState,
          activeDropdown: dropdown,
          activeLink: activeLink
        }
      })
    }
  }

  openQuiz(e, fetch = true) {
    if (fetch) {
      let quizslug = e.target.getAttribute("data-id")
      this.props.loadQuiz(quizslug)
    }
    this.setState(prevState => {
      return {
        ...prevState,
        quizactive: !prevState.quizactive
      }
    })
    document.querySelector("body").className = "overflow"
  }
  closeQuiz(success) {
    this.setState(prevState => {
      return {
        ...prevState,
        quizactive: !prevState.quizactive
      }
    })
    if (success) {
      document.location.reload()
    }
    document.querySelector("body").className = ""
  }

  async markAsRead(id, lang) {
    try {
      const response = await api.markLearningArticleAsRead(id, lang)

      this.maybeTrackResponse(response)
    } catch (e) {
      log.dir(e)
    }
  }
  openVideo(e) {
    let videoURL = e.target.getAttribute("data-video")
    let modulename = e.target.getAttribute("data-modulename")
    let articlename = e.target.getAttribute("data-articlename")
    let articleID = e.target.getAttribute("data-id")
    this.setState(prevState => {
      return {
        ...prevState,
        videoactive: !prevState.videoactive
      }
    })
    this.setState({
      currentvideo: videoURL,
      modulename: modulename,
      articlename: articlename
    })
    this.markAsRead(articleID, this.props.lang)
    this.modalVideo.current.load()
    document.querySelector("body").className = "overflow"
  }
  closeVideo() {
    this.setState(prevState => {
      return {
        ...prevState,
        videoactive: !prevState.videoactive
      }
    })
    this.setState({
      currentvideo: "",
      modulename: "",
      articlename: ""
    })
    document.location.reload()
    document.querySelector("body").className = ""
  }

  getThemeNav() {
    const {topic, t, lang} = this.props
    const prev_topic = topic.prev_topic
    const next_topic = topic.next_topic

    return (
      <div className="theme--nav nav-black">
        <Container>
          <Row>
            <Col size={12} lg={6} className="theme__breadcrumb">
              <ul>
                <li>
                  <Link href={`/${lang}/learning/topics`}>
                    <span>{t("Akademie")}</span>
                  </Link>
                </li>
                <li>
                  <span dangerouslySetInnerHTML={{__html: topic.name}} />
                </li>
              </ul>
            </Col>
            <Col size={12} lg={6}>
              <ul>
                <li className={prev_topic ? "prev" : "prev --disabled"}>
                  {prev_topic ? (
                    <ul className="prev-post">
                      <li>
                        <span className="headline">
                          {textTruncate(prev_topic.name, true, 8, "...")}
                        </span>
                        {prev_topic.fields.image ? (
                          <span className="img">
                            <img
                              src={prev_topic.fields.image}
                              alt="preview prev"
                            />
                          </span>
                        ) : null}
                      </li>
                    </ul>
                  ) : null}
                  <i className="icon-arrow-left" />
                  {prev_topic ? (
                    <Link
                      href={`/${lang}/learning/topic/${prev_topic.term_id}`}
                      data-action="prevCourse"
                    >
                      {t("Vorheriger Kurs")}
                    </Link>
                  ) : (
                    `${t("Vorheriger Kurs")}`
                  )}
                </li>
                <li className="back">
                  <i />
                  <Link href={`/${lang}/learning/topics`}>
                    {t("Zur Kursübersicht")}
                  </Link>
                </li>
                <li className={next_topic ? "next" : "next --disabled"}>
                  {next_topic ? (
                    <Link
                      href={`/${lang}/learning/topic/${next_topic.term_id}`}
                      data-action="nextCourse"
                    >
                      {t("Nächster Kurs")}
                    </Link>
                  ) : (
                    `${t("Nächster Kurs")}`
                  )}
                  <i className="icon-arrow-right" />
                  {next_topic ? (
                    <ul className="next-post">
                      <li>
                        <span className="headline">
                          {textTruncate(next_topic.name, true, 8, "...")}
                        </span>
                        {next_topic.fields.image ? (
                          <span className="img">
                            <img
                              src={next_topic.fields.image}
                              alt="preview next"
                            />
                          </span>
                        ) : null}
                      </li>
                    </ul>
                  ) : null}
                </li>
              </ul>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }

  getTopicName() {
    return typeof this.props.topic === "undefined"
      ? null
      : this.props.topic.name
  }

  renderModuleArticles(quizevent, videoevent, modulename, lang, t, item, key) {
    return (
      <li
        className={`${
          typeof item.is_quiz !== "undefined" && item.is_quiz ? "quiz" : ""
        } ${item.is_read ? "done" : ""}`}
        key={key}
      >
        {typeof item.is_quiz !== "undefined" && item.is_quiz ? (
          <span data-id={item.ID} className="title" onClick={quizevent}>
            {item.post_title}
          </span>
        ) : typeof item.is_video !== "undefined" && item.is_video ? (
          <span
            data-id={item.ID}
            data-modulename={modulename}
            data-articlename={item.post_title}
            data-video={`${
              typeof item.fields.video_id !== "undefined" &&
              item.fields.video_id
                ? item.fields.video_url
                : ""
            }`}
            className="title"
            onClick={videoevent}
          >
            {item.post_title}
          </span>
        ) : (
          <Link href={`/${lang}/learning/article/` + item.ID}>
            <span>{item.post_title}</span>
          </Link>
        )}
        {item.is_new && <span className="badge-new">{t("NEU")}</span>}
        <span className="time">
          <i className="icon icon-clock" />
          <span>{item.fields.reading_time} Min.</span>
        </span>
        {typeof item.is_quiz !== "undefined" && item.is_quiz ? (
          <span className="status icon icon-trophy">
            {item.is_read ? <span className="icon-ico-state-done" /> : null}
          </span>
        ) : typeof item.is_video !== "undefined" && item.is_video ? (
          <span className="status icon icon-video-play">
            {item.is_read ? <span className="icon-ico-state-done" /> : null}
          </span>
        ) : (
          <span className="status icon icon-articles">
            {item.is_read ? <span className="icon-ico-state-done" /> : null}
          </span>
        )}
      </li>
    )
  }

  getModuleArticleTitles({articles}) {
    return articles.reduce((acc, a) => {
      if (a.is_read) {
        acc.push(a.post_title)
      }

      return acc
    }, [])
  }

  getModules() {
    const {topic, t, lang} = this.props
    const quizevent = this.openQuiz
    const videoevent = this.openVideo
    const modules = this._getAvailableModules()

    return modules.map((module, index) => {
      const quizArticles = module.articles.filter(function(item) {
        return item.is_quiz === true
      })
      const quizDoneArticles = module.articles.filter(function(item) {
        return item.is_quiz === true && item.is_read === true
      })

      const learningProgress =
        ((module.read_articles > module.number_articles
          ? module.number_articles
          : module.read_articles) *
          100) /
        module.number_articles

      return (
        <div
          ref={elem => this._setModuleRef(`module-${module.term_id}`, elem)}
          id={`module-${module.term_id}`}
          className={`
        ${styles.Module}
        module
        ${
          !module.is_available
            ? "is-closed"
            : module.is_available &&
              !module.is_read &&
              module.read_articles === 0
              ? "is-available"
              : module.is_available && module.is_read
                ? "is-done"
                : "in-progress"
        }
        `}
          key={module.term_id}
        >
          {module.is_final_quiz || module.is_quiz ? (
            <div className="teaser teaser-last">
              <div className="count-holder">
                <span>
                  <i className="icon-trophy" />
                </span>
              </div>
              <div className="teaser-content">
                <div className="content-holder">
                  <h3 id={`anchor${index}`} className="headline">
                    {module.name}
                  </h3>
                  {topic.optional_modules.includes(module.term_id) ? (
                    <span className="optional">{t("optional")}</span>
                  ) : null}
                  <p
                    className="description"
                    dangerouslySetInnerHTML={{__html: module.description}}
                  />
                </div>
                <div
                  className={`
                info-holder
                ${
                  !module.is_available
                    ? "is-closed"
                    : module.is_available &&
                      !module.is_read &&
                      module.read_articles === 0
                      ? "is-available"
                      : module.is_available && module.is_read
                        ? "is-done"
                        : "in-progress"
                }
              `}
                >
                  <div
                    data-id={module.articles[0].ID}
                    className="button-holder"
                    onClick={this.openQuiz}
                  >
                    <div className="button  button--purple button--small button--inline button--none">
                      <a>
                        <span>{t("Quiz starten")}</span>
                        <i className="button__icon icon--default" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : module.is_standalone_video ? (
            <div className="teaser teaser-standalone_video">
              <div className="count-holder">
                <span>
                  <i className="icon-video-play" />
                </span>
              </div>
              <div className="teaser-content">
                <div className="content-holder">
                  <h3 id={`anchor${index}`} className="headline">
                    {module.name}
                  </h3>
                  {topic.optional_modules.includes(module.term_id) ? (
                    <span className="optional">{t("optional")}</span>
                  ) : null}
                  <p
                    className="description"
                    dangerouslySetInnerHTML={{__html: module.description}}
                  />
                </div>
                <div
                  className={`
                info-holder
                ${
                  !module.is_available
                    ? "is-closed"
                    : module.is_available &&
                      !module.is_read &&
                      module.read_articles === 0
                      ? "is-available"
                      : module.is_available && module.is_read
                        ? "is-done"
                        : "in-progress"
                }
              `}
                >
                  <div
                    data-id={module.articles[0].ID}
                    data-modulename={module.name}
                    data-articlename={module.articles[0].post_title}
                    data-video={`${
                      typeof module.articles[0].fields.video_id !==
                        "undefined" && module.articles[0].fields.video_id
                        ? module.articles[0].fields.video_url
                        : ""
                    }`}
                    className="button-holder"
                    onClick={this.openVideo}
                  >
                    <div className="button  button--purple button--small button--inline button--none">
                      <a>
                        <span>{t("Video abspielen")}</span>
                        <i className="button__icon icon--default" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="teaser">
              <ModuleCertificate
                moduleId={module.term_id}
                moduleName={module.name}
                articleTitles={this.getModuleArticleTitles(module)}
                username={this.props.userdata.user.display_name}
                date={dateToString(module.read_date, lang)}
                isPrinting={this.state.moduleCertificateId === module.term_id}
                closePrintDialog={this.closePrintModuleCertificate}
              />
              <div className="count-holder">
                <span>{index + 1}</span>
              </div>
              <div className="teaser-content">
                <div className="content-holder">
                  <h3 id={`anchor${index}`} className="headline">
                    {module.name}
                  </h3>
                  {topic.optional_modules.includes(module.term_id) ? (
                    <span className="optional">{t("optional")}</span>
                  ) : null}
                  <p
                    className="description"
                    dangerouslySetInnerHTML={{__html: module.description}}
                  />
                  <ul className="meta">
                    {module.is_new_module && (
                      <li className="badge-new">{t("NEUES MODUL")}</li>
                    )}
                    {module.is_new && (
                      <li className="badge-new">{t("NEUE ARTIKEL")}</li>
                    )}
                    <li>
                      <i className="icon-userlevel" />
                      <span>{module.fields.difficulty}</span>
                    </li>
                    <li>
                      <i className="time icon icon-clock" />
                      <span>{module.fields.reading_time} Min.</span>
                    </li>
                    {!checkEnv("DISABLE_PRINTING") && (
                      <li className="action-print has-icon">
                        <a
                          value={module.term_id}
                          href={module.term_id}
                          onClick={e => this.fetchArticles(e)}
                        >
                          <span className="icon-block">
                            <i className="icon icon-print" />
                          </span>
                          <span className="title">{t("Drucken")}</span>
                        </a>
                      </li>
                    )}
                    {module.is_read ? (
                      <li className="action-print has-icon cert">
                        <button
                          onClick={e => {
                            e.preventDefault()
                            this.printModuleCertificate(module.term_id)
                          }}
                        >
                          <span className="icon-block">
                            <i className="icon icon-cert-download" />
                          </span>
                          <span className="title">{t("Zertifikat")}</span>
                        </button>
                      </li>
                    ) : null}
                  </ul>
                </div>
                <div
                  className={`
                  info-holder
                  ${
                    !module.is_available
                      ? "is-closed"
                      : module.is_available &&
                        !module.is_read &&
                        module.read_articles === 0
                        ? "is-available"
                        : module.is_available && module.is_read
                          ? "is-done"
                          : "in-progress"
                  }
                `}
                >
                  <div className="info">
                    <ul>
                      <li className="status">
                        <i
                          className={`
                        ${
                          !module.is_available
                            ? "icon-ico-state-locked"
                            : module.is_available &&
                              !module.is_read &&
                              module.read_articles === 0
                              ? "icon-ico-state-todo"
                              : module.is_available && module.is_read
                                ? "icon-ico-state-done"
                                : "icon-ico-state-wip"
                        }
                      `}
                        />
                      </li>
                      <li className="articles">
                        <i className="icon-articles" />
                        <span>
                          {Math.max(
                            0,
                            module.read_articles - quizDoneArticles.length
                          )}
                          /
                          {module.number_articles - quizArticles.length}
                        </span>
                      </li>
                      <li className="quiz">
                        <i className="icon-trophy" />
                        <span>
                          {quizDoneArticles.length}/{quizArticles.length}
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div className="progress">
                    <span style={{width: learningProgress + "%"}}>
                      {Math.floor(learningProgress)}%
                    </span>
                  </div>
                  <div
                    className="button-holder"
                    onClick={e =>
                      !module.is_available ? null : this.slideToggle(e)
                    }
                  >
                    <div className="button  button--purple button--small button--inline button--none">
                      <a>
                        <span>{t("Artikel einblenden")}</span>
                        <span className="is-open">
                          {t("Artikel ausblenden")}
                        </span>
                        <i className="button__icon icon--default" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="articles-list">
                <div className="list-items">
                  <ul>
                    {module.articles.map(
                      this.renderModuleArticles.bind(
                        null,
                        quizevent,
                        videoevent,
                        module.name,
                        lang,
                        t
                      )
                    )}
                  </ul>
                </div>
              </div>
            </div>
          )}
        </div>
      )
    })
  }

  renderAnchorNav() {
    const modules = this._getAvailableModules()

    return modules.map((module, index) => {
      return (
        <li
          className={`
        ${
          !module.is_available
            ? "is-closed"
            : module.is_available &&
              !module.is_read &&
              module.read_articles === 0
              ? "is-available"
              : module.is_available && module.is_read
                ? "is-done"
                : "in-progress"
        }
        `}
          key={module.term_id}
        >
          <a data-scroll href={`#anchor${index}`}>
            <span className="count">{index + 1}</span>
            <span>{module.name}</span>
          </a>
        </li>
      )
    })
  }

  getArticlesList() {
    const {articles} = this.props
    return articles.posts.map((post, index) => {
      return (
        <li key={post.ID}>
          <span>{`${index + 1}.`}</span>
          <span>{post.post_title}</span>
        </li>
      )
    })
  }

  getArticles() {
    const {articles} = this.props
    return articles.posts.map(post => {
      return (
        <div className="module-post" key={post.ID}>
          <h2>{post.post_title}</h2>
          <RemoteContent>{post.post_content}</RemoteContent>
        </div>
      )
    })
  }

  maybeTrackResponse(resp) {
    if (resp.status === "success") {
      // article
      this.props.addTracking({
        event: "mtm.finishedSection",
        section_finished: "article"
      })

      // module
      if (resp.completed_module) {
        this.props.addTracking({
          event: "mtm.finishedSection",
          section_finished: "module"
        })
      }

      // topic
      if (resp.completed_topic) {
        this.props.addTracking({
          event: "mtm.finishedSection",
          section_finished: "course"
        })
      }
    }
  }

  getFilename(url) {
    return url.split(/[\\/]/).pop()
  }

  _unsetTag(tagGroup) {
    const tagFilters = this.state.tagFilters

    if (tagFilters[tagGroup]) {
      delete tagFilters[tagGroup]

      this.setState(prevState => {
        return {
          ...prevState,
          tagFilters
        }
      })
    }
  }

  _setTag(tagGroup, tagKey) {
    this.setState(prevState => {
      return {
        ...prevState,
        tagFilters: {
          ...prevState.tagFilters,
          [tagGroup]: tagKey
        }
      }
    })
  }

  renderTagsFilter() {
    const {tags, t} = this.props
    const availableTags = this._getAvailableTagGroups()

    return Object.keys(tags).map((tagGroup, index) => {
      const tagGroupIsDisabled = availableTags[tagGroup] ? false : true

      return (
        <div
          className={`filter-wrap ${tagGroupIsDisabled && "disabled"}`}
          key={`group-${index}`}
        >
          <span
            className="placeholder icon icon-arrow-down"
            onClick={e => this.slideDropdownToggle(e)}
          >
            {(this.state.tagFilters[tagGroup] &&
              tags[tagGroup][this.state.tagFilters[tagGroup]]) ||
              tagGroup}
          </span>
          <div className="filter">
            {this.state.tagFilters[tagGroup] && (
              <button onClick={() => this._unsetTag(tagGroup)}>
                {t("--- Zurücksetzen ---")}
              </button>
            )}
            {Object.keys(tags[tagGroup]).map(tagKey => {
              const tagIsDisabled =
                !tagGroupIsDisabled && availableTags[tagGroup][tagKey]
                  ? false
                  : true

              if (tagIsDisabled) {
                return (
                  <button
                    className="disabled"
                    onClick={() => {}}
                    key={`tag-${tagKey}`}
                  >
                    {tags[tagGroup][tagKey]}
                  </button>
                )
              } else {
                return (
                  <button
                    onClick={() => this._setTag(tagGroup, tagKey)}
                    key={`tag-${tagKey}`}
                  >
                    {tags[tagGroup][tagKey]}
                  </button>
                )
              }
            })}
          </div>
        </div>
      )
    })
  }

  _getAvailableModules() {
    const tagFilters = Object.values(this.state.tagFilters)

    return this.props.modules.reduce((acc, module) => {
      const matches = tagFilters.every(t => module.fields.tags.includes(t))

      if (matches || tagFilters.length === 0) {
        acc.push(module)
      }

      return acc
    }, [])
  }

  _getAvailableTags() {
    const modules = this._getAvailableModules()

    return modules.reduce((acc, module) => {
      return acc.concat(module.fields.tags)
    }, [])
  }

  _getAvailableTagGroups() {
    const {tags} = this.props

    const availableTags = this._getAvailableTags()

    return Object.keys(tags).reduce((acc, tagGroupKey) => {
      const filteredTags = Object.keys(tags[tagGroupKey]).reduce(
        (acc2, tag) => {
          if (!availableTags.includes(tag)) {
            delete acc2[tag]
          }

          return acc2
        },
        {...tags[tagGroupKey]}
      )

      if (Object.keys(filteredTags).length > 0) {
        acc[tagGroupKey] = filteredTags
      }

      return acc
    }, {})
  }

  renderContentEndNav() {
    const {
      topic: {prev_topic, next_topic},
      t,
      lang
    } = this.props

    return (
      <div className="post-end-nav">
        {/* prev topic link */}
        {prev_topic ? (
          <Button
            to={`/${lang}/learning/topic/${prev_topic.term_id}`}
            theme="dark"
            icon="prev"
            iconPosition="before"
            data-action="prevCourse"
          >
            {t("Vorheriger Kurs")}
          </Button>
        ) : (
          <Button
            theme="dark"
            icon="prev"
            iconPosition="before"
            disabled={true}
            onClick={() => {}}
          >
            {t("Vorheriger Kurs")}
          </Button>
        )}
        {/* next topic link */}
        {next_topic ? (
          <Button
            to={`/${lang}/learning/topic/${next_topic.term_id}`}
            theme="dark"
            data-action="prevCourse"
          >
            {t("Nächster Kurs")}
          </Button>
        ) : (
          <Button theme="dark" disabled={true} onClick={() => {}}>
            {t("Nächster Kurs")}
          </Button>
        )}
      </div>
    )
  }

  _closeFeedbackModal() {
    this.setState(prevState => {
      return {
        ...prevState,
        feedbackVisible: false
      }
    })
  }

  _openFeedbackModal() {
    this.setState(prevState => {
      return {
        ...prevState,
        feedbackVisible: true
      }
    })
  }

  renderFeedback() {
    const {topic, t} = this.props

    return (
      <div
        className={`${styles.Module} module ${
          topic.feedback_sent ? "is-done" : "is-available"
        }`}
      >
        <div className="teaser teaser-last">
          <div className="count-holder">
            <span>
              <i className="icon-feedback-star-filled" />
            </span>
          </div>
          <div className="teaser-content">
            <div className="content-holder">
              <h3 className="headline">{t("Feedback")}</h3>
              <span className="optional">{t("optional")}</span>
              <p className="description">
                {t(
                  "Nach Abschluss des Kurses hast du die Möglichkeit uns Feedback zu geben. Wurde etwas vergessen? Was war zu einfach, was zu schwer? Gib uns Bescheid."
                )}
              </p>
            </div>
            <div className="info-holder is-available">
              <div
                className="button-holder"
                onClick={() => this._openFeedbackModal()}
              >
                <div className="button button--purple button--small button--inline button--none">
                  <a>
                    <span>{t("Feedback abgeben")}</span>
                    <i className="button__icon icon--default" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Feedback
          intro={topic.feedback.intro}
          outro={topic.feedback.outro}
          questions={topic.feedback.questions}
          submitResponse={data =>
            this.props.addFeedback(
              topic.fields.feedback_id,
              data,
              topic.term_id
            )
          }
          closeModal={() => this._closeFeedbackModal()}
          topicName={topic.name}
          active={this.state.feedbackVisible}
        />
      </div>
    )
  }

  _getHash() {
    return this.props.router.hash === ""
      ? null
      : this.props.router.hash.replace("#", "")
  }

  _setModuleRef(name, elem) {
    this.moduleRefs[name] = elem
  }

  _scrollToModule(hash) {
    const node = this.moduleRefs[hash]

    if (node) {
      this.setState(prevState => {
        return {...prevState, lastUsedHash: hash}
      })

      // scroll to node
      setTimeout(() => {
        const bounding = node.getBoundingClientRect()
        const scrollValue = Math.floor(bounding.top) + window.scrollY - 115 // last value is safe space

        window.scrollTo(0, scrollValue)
      }, 350)
    }
  }

  render() {
    const {error, fetching, modules, quizpost, lang, topic, t} = this.props

    if (typeof this.props.topic === "undefined") {
      return null
    }

    if (error) {
      return (
        <Message error>
          <p>
            <strong>{t("Es ist ein Fehler aufgetreten.")}</strong>
            <br />
            {error}
          </p>
        </Message>
      )
    }

    const doneModules = modules.filter(item => {
      return item.is_read === true
    })
    const wipModules = modules.filter(item => {
      return item.is_available === true && item.read_articles > 0
    })
    const modulesNames = modules.reduce((acc, i) => {
      if (i.is_read) {
        return [...acc, i.name]
      } else {
        return acc
      }
    }, [])
    let currentDate = new Date()
    let month = currentDate.getMonth() + 1
    let day = currentDate.getDate()
    let year = currentDate.getFullYear()
    currentDate = day + "." + month + "." + year

    return (
      <div>
        <Loader active={this.props.fetching} />
        <Col
          className={`modal-print ${this.state.isPrinting ? "is-active" : ""}`}
        >
          <button onClick={this.closePrint}>
            <i className="icon icon-close" />
          </button>
          <div>{t("Druckfunktion wird geladen...")}</div>
        </Col>
        <Col
          className={`modal-print ${
            this.state.isGlobalPrinting ? "is-active" : ""
          }`}
        >
          <button onClick={this.closeGlobalPrint}>
            <i className="icon icon-close" />
          </button>
          <div>{t("Druckfunktion wird geladen...")}</div>
        </Col>
        <Col
          className={`modal-video ${this.state.videoactive ? "is-active" : ""}`}
        >
          <div className="video_container">
            <div className="head">
              <div className="title">
                <span>{this.state.modulename}</span>
                <i className="icon-arrow-right" />
                <span>{this.state.articlename}</span>
              </div>
              <button onClick={this.closeVideo}>
                <i className="icon icon-close" />
              </button>
            </div>
            <div className="inner">
              <video
                data-video-title={this.getFilename(this.state.currentvideo)}
                controls
                autoPlay
                name="media"
                ref={this.modalVideo}
              >
                <source src={this.state.currentvideo} type="video/mp4" />
              </video>
            </div>
          </div>
        </Col>
        {!this.props.fetching ? (
          <Certificate
            username={this.state.username}
            topicname={this.props.topic.name}
            modulesNames={modulesNames}
            currentDate={dateToString(this.props.topic.completed_at, lang)}
            isCrtPrinting={this.state.isCrtPrinting}
            closeCrtPrint={this.closeCrtPrint}
          />
        ) : null}
        <div className={`${styles.IntroBlock} intro-block`}>
          <Container>
            <Row className="row-fluid">
              <Col md={10} xl={7} className="col-left">
                <div className="wp-content">
                  <Row className="row-fluid">
                    <Col>
                      <div className="text_column">
                        <h1
                          className="headline"
                          dangerouslySetInnerHTML={{
                            __html: this.props.topic.name
                          }}
                        />
                        <p
                          className="description no-margin"
                          dangerouslySetInnerHTML={{
                            __html: this.props.topic.description
                          }}
                        />
                        {topic.is_new && (
                          <span className="badge-new">{t("NEU")}</span>
                        )}
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
              <Col md={2} xl={3} offsetXl={1} className="col-right">
                <div className="image-holder">
                  <img src={graphicAcademyMed} alt="Academy" />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        {this.state.isPrinting || this.state.isGlobalPrinting ? (
          <table className="print-table">
            <thead>
              <tr>
                <td>
                  <div className="header-space">&nbsp;</div>
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  {this.state.isPrinting && !this.props.fetching ? (
                    <div className={styles.Modules}>
                      <div className="inside">
                        <Container className="modules-contents">
                          <Row className="row-fluid">
                            <Col>
                              <p className="title-print">
                                {t("Übersicht Artikel")}
                              </p>
                              <ul className="table-of-contents">
                                {this.getArticlesList()}
                              </ul>
                            </Col>
                          </Row>
                        </Container>
                      </div>
                      <div className="inside">
                        <Container className="modules-list">
                          <Row className="row-fluid">
                            <Col>
                              {this.getArticles()}
                              {this.doPrint()}
                            </Col>
                          </Row>
                        </Container>
                      </div>
                    </div>
                  ) : (
                    <div className={styles.Modules}>
                      <div className="inside">
                        {this.getThemeNav()}
                        <div className={`${styles.FilterBar} filter-bar`}>
                          <Container>
                            <Row
                              className="row-fluid"
                              justifyContent="between"
                              alignItems="center"
                            >
                              <Col className="progress-info" lg={4}>
                                <div className="progress">
                                  <p>
                                    <i className="icon-modules" />
                                    <span>
                                      <b>
                                        {doneModules.length > modules.length
                                          ? modules.length
                                          : doneModules.length}/{modules.length}
                                      </b>{" "}
                                      {t("Module erledigt")}{" "}
                                      <span className="additional">
                                        |{" "}
                                        <b>
                                          {modules.length - doneModules.length}
                                        </b>{" "}
                                        {t("Module in Bearbeitung")}
                                      </span>
                                    </span>
                                  </p>
                                </div>
                                <div className="status">
                                  <span
                                    style={{
                                      width: topic.progress_percent + "%"
                                    }}
                                  >
                                    {topic.progress_percent}%
                                  </span>
                                </div>
                              </Col>
                              <Col className="status-info" lg={4}>
                                <ul>
                                  <li className="closed">
                                    <i />
                                    <span>{t("Gesperrt")}</span>
                                  </li>
                                  <li className="available">
                                    <i />
                                    <span>{t("Verfügbar")}</span>
                                  </li>
                                  <li className="wip">
                                    <i />
                                    <span>{t("In Bearbeitung")}</span>
                                  </li>
                                  <li className="done">
                                    <i />
                                    <span>{t("Erledigt")}</span>
                                  </li>
                                </ul>
                              </Col>
                              {!checkEnv("DISABLE_PRINTING") && (
                                <Col
                                  className="action-print has-icon col"
                                  lg={4}
                                >
                                  <a
                                    onClick={this.doGlobalPrint}
                                    data-action="print"
                                  >
                                    <span className="icon-block">
                                      <i className="icon icon-print" />
                                    </span>
                                    <span className="title">
                                      {t("Kurs drucken")}
                                    </span>
                                  </a>
                                </Col>
                              )}
                            </Row>
                          </Container>
                        </div>
                        <Container className="modules-list">
                          <Row className="row-fluid">
                            <Col md={8}>
                              <p className="title-print">
                                {t("Übersicht Modul")}
                              </p>
                              {this.getModules()}
                            </Col>
                          </Row>
                        </Container>
                      </div>
                    </div>
                  )}
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td>
                  <div className="footer-space">&nbsp;</div>
                </td>
              </tr>
            </tfoot>
          </table>
        ) : (
          <div className={styles.Modules}>
            <div className="inside">
              {this.getThemeNav()}
              <div
                className={`${styles.FilterBar} filter-bar ${
                  Math.floor(topic.progress_percent) === 0
                    ? "is-available"
                    : topic.progress_percent >= 1 &&
                      topic.progress_percent <= 99
                      ? "in-progress"
                      : "done"
                }`}
              >
                <Container>
                  <Row
                    className="row-fluid"
                    justifyContent="between"
                    alignItems="center"
                  >
                    <Col className="progress-info" lg={4}>
                      <div className="progress">
                        <p>
                          <i className="icon-modules" />
                          <span>
                            <b>
                              {doneModules.length > modules.length
                                ? modules.length
                                : doneModules.length}/{modules.length}
                            </b>{" "}
                            {modules.length > 1
                              ? t("Modulen erledigt")
                              : t("Modul erledigt")}
                            <span className="additional">
                              | <b>{wipModules.length - doneModules.length}</b>{" "}
                              {wipModules.length - doneModules.length === 1
                                ? t("Modul in Bearbeitung")
                                : t("Module in Bearbeitung")}
                            </span>
                          </span>
                        </p>
                      </div>
                      <div className="status">
                        <span
                          className="percent"
                          style={{width: topic.progress_percent + "%"}}
                        >
                          {topic.progress_percent}%
                        </span>
                      </div>
                    </Col>
                    <Col className="status-info" lg={4}>
                      <ul>
                        <li className="closed">
                          <i />
                          <span>{t("Gesperrt")}</span>
                        </li>
                        <li className="available">
                          <i />
                          <span>{t("Verfügbar")}</span>
                        </li>
                        <li className="wip">
                          <i />
                          <span>{t("In Bearbeitung")}</span>
                        </li>
                        <li className="done">
                          <i />
                          <span>{t("Erledigt")}</span>
                        </li>
                      </ul>
                    </Col>

                    <Col className="action-print has-icon col" lg={4}>
                      {topic.completed_at ? (
                        <a onClick={this.doCrtPrint} data-action="certificate">
                          <span className="icon-block">
                            <i className="icon icon-cert-download" />
                          </span>
                          <span className="title">
                            {t("Zertifikat herunterladen")}
                          </span>
                        </a>
                      ) : null}
                      {!checkEnv("DISABLE_PRINTING") && (
                        <a onClick={this.doGlobalPrint} data-action="print">
                          <span className="icon-block">
                            <i className="icon icon-print" />
                          </span>
                          <span className="title">{t("Kurs drucken")}</span>
                        </a>
                      )}
                    </Col>
                  </Row>
                  {!checkEnv("DISABLE_LEARNING_TAGS") &&
                    this._getAvailableTags().length > 0 && (
                      <Row className="hide-mobile">
                        <Col className="tags-filter">
                          <span className="title">{t("Filtern nach")}:</span>
                          <div className="tags-filter__inner">
                            {this.renderTagsFilter()}
                          </div>
                        </Col>
                      </Row>
                    )}
                </Container>
              </div>
              <Container className="modules-list">
                <Row className="row-fluid">
                  <Col lg={4} className="sidebar sidebar-anchors">
                    <nav className="nav-anchor learning">
                      <p className="title icon">{t("Lernfortschritt")}</p>
                      <div>{this.renderAnchorNav()}</div>
                    </nav>
                  </Col>
                  <Col lg={8}>
                    <p className="title-print">{t("Übersicht Modul")}</p>
                    {/* Modules */}
                    {this.getModules()}
                    {/* Feedback */}
                    {topic.feedback &&
                    topic.feedback.questions.length > 0 &&
                    topic.progress_percent === 100
                      ? this.renderFeedback()
                      : null}
                  </Col>
                  {/* Quiz */}
                  {!fetching && this.state.quizactive ? (
                    <div
                      className={`quiz-modal ${
                        this.state.quizactive ? "active" : ""
                      }`}
                    >
                      <Quiz
                        fetching={fetching}
                        postID={quizpost.ID}
                        topicslug={quizpost.topic.ID}
                        questions={quizpost.quiz}
                        modulename={quizpost.module.name}
                        quizname={quizpost.post_title}
                        quizdescription={quizpost.quiz.description}
                        closeQuiz={this.closeQuiz}
                        questionslength={quizpost.quiz.questions.length}
                      />
                    </div>
                  ) : null}
                </Row>
                {this.renderContentEndNav()}
              </Container>
            </div>
            {/* / inside */}
          </div>
        )}
        <div className="page-footer">
          <Container>
            <Row className="d-print-block">
              <Col>
                <p>{this.props.topic.name}</p>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {...state.learningmodules, lang: state.app.lang, router: state.router}
}

const mapDispatchToProps = dispatch => {
  return {
    addTracking: data => dispatch(AppCreators.trackingAdd(data)),
    loadArticles: moduleslug => dispatch(Creators.articlesRequest(moduleslug)),
    loadQuiz: quizslug => dispatch(Creators.quizRequest(quizslug)),
    addFeedback: (feedbackId, data, topicId) =>
      dispatch(Creators.feedbackRequest(feedbackId, data, topicId))
  }
}

// export default connect(mapStateToProps)(LearningModules)
LearningModules = connect(
  mapStateToProps,
  mapDispatchToProps
)(LearningModules)
export default translate()(LearningModules)

export {reducer} from "./redux"
export {default as sagas} from "./sagas"



// WEBPACK FOOTER //
// ./src/containers/LearningModules/index.js